import type { PaymentMethodSummary } from "@/api/contracts/customer.contract";

const BRAND_LABELS: Record<string, string> = {
  visa: "Visa",
  mastercard: "Mastercard",
  amex: "American Express",
  discover: "Discover",
  diners: "Diners Club",
  jcb: "JCB",
  unionpay: "UnionPay",
};

function formatBrand(brand: string | null): string {
  if (!brand) return "Card";
  return BRAND_LABELS[brand.toLowerCase()] ?? brand;
}

function formatExpiry(month: number | null, year: number | null): string | null {
  if (!month || !year) return null;
  return `${String(month).padStart(2, "0")}/${year}`;
}

/**
 * Read-only summary of the patient's saved card. Stripe is the source of truth,
 * so this only ever shows the last four digits and expiry — never full details.
 */
export function SavedCardSummary({ card }: { card: PaymentMethodSummary }) {
  const expiry = formatExpiry(card.expMonth, card.expYear);

  return (
    <div className="flex items-center gap-3 rounded-[0.625rem] border border-border bg-muted/30 px-4 py-3">
      <div className="flex h-8 w-12 shrink-0 items-center justify-center rounded-md bg-brand-ink text-[10px] font-semibold uppercase tracking-wide text-brand-ink-contrast">
        {formatBrand(card.brand).slice(0, 4)}
      </div>
      <div className="min-w-0">
        <p className="text-sm font-medium text-foreground">
          {formatBrand(card.brand)}{" "}
          <span className="text-muted-foreground">•••• {card.last4}</span>
        </p>
        {expiry && (
          <p className="text-xs text-muted-foreground">Expires {expiry}</p>
        )}
      </div>
    </div>
  );
}
